export default "__VITE_ASSET__D15B$y1A__"